const Comparator = Object.freeze({
  AND: 'AND',
  OR: 'OR',
});

export default Comparator;
